export default __webpack_public_path__ + "static/media/search.d1a90e76.svg";